import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { BookOpen, FolderKanban, LayoutDashboard, PlugZap, Rocket } from 'lucide-react'

const NAV_ITEMS: { to: string; icon: typeof LayoutDashboard; label: string; ariaLabel?: string; attention?: boolean }[] = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/quick-start', icon: Rocket, label: 'Quick Start', ariaLabel: 'Open the Quick Start guide', attention: true },
  { to: '/catalog', icon: BookOpen, label: 'Catalog' },
  { to: '/projects', icon: FolderKanban, label: 'My Projects' },
  { to: '/mcp-registry', icon: PlugZap, label: 'MCP Registry' },
]

export function Sidebar() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem('qs_seen') === '1')
  return (
    <aside style={{
      width: 220, minHeight: '100vh', background: 'var(--surface)',
      borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column',
      padding: 'var(--space-3) 0', flexShrink: 0,
    }}>
      {/* Logo */}
      <div style={{
        padding: '0 var(--space-3) var(--space-2)',
        borderBottom: '1px solid var(--border-subtle)',
        marginBottom: 'var(--space-2)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <img src="/favicon.svg" alt="KONE" width="28" height="28" style={{ flexShrink: 0 }} />
          <div>
            <div style={{ fontSize: 'var(--text-body1-size)', fontWeight: 700, letterSpacing: '-0.5px', color: 'var(--text-primary)' }}>
              Context Lake
            </div>
            <div style={{ fontSize: 'var(--text-body3-size)', color: 'var(--text-muted)', marginTop: 1 }}>
              KONE Engineering AI
            </div>
          </div>
        </div>
      </div>

      {/* Primary navigation */}
      <nav style={{ flex: 1, padding: '0 var(--space-15)' }}>
        {NAV_ITEMS.map(({ to, icon: Icon, label, ariaLabel, attention }) => {
          const showAttention = attention && !dismissed
          return (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            aria-label={ariaLabel}
            className={`sidebar-nav-link${showAttention ? ' sidebar-nav-link--attention' : ''}`}
            onClick={() => { if (attention) { setDismissed(true); localStorage.setItem('qs_seen', '1') } }}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: 'var(--space-15)',
              padding: 'var(--space-1) var(--space-15)', borderRadius: 'var(--radius-xs)',
              fontSize: 'var(--text-body2-size)', fontWeight: isActive ? 500 : 400,
              color: isActive ? 'var(--brand)' : 'var(--text-secondary)',
              background: isActive ? 'rgba(25,100,250,0.1)' : 'transparent',
              textDecoration: 'none', marginBottom: 2, transition: 'all var(--transition-fast)',
            })}
          >
            <Icon size={15} />
            {showAttention ? <span className="sidebar-nav-link--attention-text">{label}</span> : label}
          </NavLink>
          )
        })}
      </nav>
    </aside>
  )
}
